import React from 'react';
import ReactGA from 'react-ga';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import AppContainer from 'react-hot-loader/lib/AppContainer';
import { calculateResponsiveState } from 'redux-responsive';
import App from './app/App';
import configureStore from './store/configure';
import './index.css';
import './assets/less/style.less';

// initialize GA
ReactGA.initialize('UA-4086578-4');
ReactGA.pageview(window.location.pathname + window.location.search);

// enable debug logging in browser
if (localStorage && process.env.NODE_ENV === 'development') {
  localStorage.debug = process.env.DEBUG;
}

const history = createHistory();
// eslint-disable-next-line no-underscore-dangle
const { store } = configureStore(history, window.__data);

const render = App =>
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <App />
      </Provider>
    </AppContainer>,
    document.getElementById('root'),
  );

if (process.env.NODE_ENV === 'development') {
  module.hot.accept('./app/App', () => {
    const NextApp = require('./app/App').default; // eslint-disable-line global-require
    render(NextApp);
  });
}

store.dispatch(calculateResponsiveState(window));
render(App);



// WEBPACK FOOTER //
// ./src/index.js